/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import { showModal } from "actions";
import i18n from "i18next";

class TrainingRequest extends Component {
  rowClassName = "";
  state = {
    showingChildren: false,
  };

  componentDidMount() { }

  componentDidUpdate(prevProps, prevState) { }

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 1:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-live-tv "></span>
          </td>
        );
      case 3:
        return (
          <td onClick={() => this.toggleChildren()} className="showGrup">
            <span className="iconmford fo-icon-tv">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      default:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-class"></span>
          </td>
        );
    }
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateColumn = (request) => {
    if (request.startDate && request.endDate) {
      return (
        <>
          {this.renderDate(request.startDate)}{" "}
          {this.renderTime(request.startDate)}
          <br />
          {this.renderDate(request.endDate)} {this.renderTime(request.endDate)}
        </>
      );
    } else {
      return (
        <>
          {request.quarter.label} - {request.quarterYear}
        </>
      );
    }
  };

  renderStatusButton = (request) => {
    //Rejected = 861110002
    if (request.status.value === 861110002) {
      return (
        <button
          className="btn-reject-reason"
          onClick={() => {
            this.props.showModal({
              modalType: "rejectReason",
              modalTitle: i18n.t("10579"),
              modalContent: request.rejectReason,
              modalFooter: null,
              modalCustomClassName: "modal-md ttModal",
            });
          }}
        >
          {request.status.label}
        </button>
      );
    }

    return request.status.label;
  };

  renderTabletModeDetail = (request) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Tarih">10572</Trans>
                  </div>
                </td>
                <td className="showGrup">{this.renderDateColumn(request)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Eğitim Yeri">10573</Trans>
                  </div>
                </td>
                <td>{request.trainingLocation}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Talep Eden">10574</Trans>
                  </div>
                </td>
                <td>{request.requestedBy?.name}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="4">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Çalışan">10575</Trans>
                  </div>
                </td>
                <td>{request.employee?.name}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="5">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Kontenjan">10576</Trans>
                  </div>
                </td>
                <td>{request?.availableQuota}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="6">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Süre">10577</Trans>
                  </div>
                </td>
                <td>
                  {request.duration / 1440}
                  <sup>
                    <Trans desc="GÜN">10388</Trans>
                  </sup>
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="7">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Talep Durumu">10578</Trans>
                  </div>
                </td>
                <td>{this.renderStatusButton(request)}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { request } = this.props;
    return (
      <>
        {this.props.spinner}
        <DesktopBreakpoint>
          <tr>
            {this.renderTrainingMethodIcon(request.trainingMethod.value)}
            <td className="showGrup">{request.training.name}</td>
            <td className="showGrup">{this.renderDateColumn(request)}</td>
            <td className="showGrup">{request.trainingLocation}</td>
            <td className="showGrup">{request.requestedBy?.name}</td>
            <td className="showGrup">{request.employee?.name}</td>
            <td className="showGrup">{request?.availableQuota}</td>
            <td className="showGrup">
              {request.duration / 1440}
              <sup>
                <Trans desc="GÜN">10388</Trans>
              </sup>
            </td>
            <td className="showGrup">{this.renderStatusButton(request)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleChildren()}
          >
            {this.renderTrainingMethodIcon(request.trainingMethod.value)}
            <td className="showGrup">{request.training.name}</td>
          </tr>
          {this.renderTabletModeDetail(request)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, { showModal })(
  containsLongRunningProcess(requireAuth(TrainingRequest))
);
